import {createStore, combineReducers, compose} from 'redux';
import puzzlesOnBoard from './puzzlesOnBoard';
import activePuzzle from './activePuzzle';
import activeButton from './activeButton';
import expandRightMenu from './expandRightMenu';
import sheets from './sheets'
import showAlert from './showAlert';
import puzzleUrl from './puzzleUrl';
import showClearAlert from './showClearAlert';
import {purePuzzles as allPurePuzzles} from '../purePuzzles'

const purePuzzles = (state = allPurePuzzles) => {
    return state;
};

const reducer = combineReducers({
    puzzleUrl,
    purePuzzles,
    puzzlesOnBoard,
    activePuzzle,
    activeButton,
    expandRightMenu,
    sheets,
    showAlert,
    showClearAlert
});

let persistedState = window.puzzleHash ? window.puzzleHash : localStorage.getItem('puzzlesState') ? JSON.parse(localStorage.getItem('puzzlesState')) : {};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer,
    persistedState,
    composeEnhancers()
);

store.subscribe(() => {
    let curState = store.getState();
    localStorage.setItem('puzzlesState', JSON.stringify(Object.assign({}, {
        puzzlesOnBoard: curState['puzzlesOnBoard']
    })))
});

export default store;


// WEBPACK FOOTER //
// ./src/state/store.js